import React, {createContext, useReducer} from 'react'
import {MHEValidationReducer} from "../reducers/MHEValidationReducer";
import {injectIntl} from "react-intl";

export const MHEValidationContext = createContext();

const MHEValidationContextProvider = (props) => {
    const data = {
        mheValidationInformation: {mheValidationInstanceList:[]},
        loadingValidationDetails: true
    }
    const [mheViewModel, mheDispatch] = useReducer(MHEValidationReducer, data)
    return (
        <MHEValidationContext.Provider value={{mheViewModel, mheDispatch}}>
            {props.children}
        </MHEValidationContext.Provider>
    )
}

export default injectIntl(MHEValidationContextProvider)



// WEBPACK FOOTER //
// ./src/components/mhevalidation/context/MHEValidationContext.js